import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Email({
  color = 'icon.primary',
  strokeWidth = '1.5',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='4 4 16 16' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.0906 10.1089L17.9523 9.52512C18.4817 9.16641 18.7988 8.56832 18.7988
         7.9287V7.9287C18.7988 6.86391 17.9357 6 16.8701 6H7.13377C6.06899 6 5.20508
          6.86316 5.20508 7.9287V7.9287C5.20508 8.56832 5.52225 9.16641 6.05162 9.52512L6.91327
           10.1089C9.98604 12.1916 14.0179 12.1916 17.0906 10.1089V10.1089Z'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M5.2002 7.93225V15.0656C5.2002 16.3169 6.21438 17.3311 7.4657 17.3311H16.5277C17.779
         17.3311 18.7932 16.3169 18.7932 15.0656V7.93225'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Email.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Email
